import http from '@/plugins/axios/axios';

export default class LimpezaPontoService {    

    listarCnpjs(filtro, pagina, totalPorPagina) {
        return http.get(`/api/empresa/listar?filtro=${filtro}&pagina=${pagina}&totalPorPagina=${totalPorPagina}`);
    }

    listarFuncionarios(cnpjId) {
        // Garantir que cnpjId é um número
        const id = typeof cnpjId === 'string' ? parseInt(cnpjId, 10) : cnpjId;
        return http.get('/api/adm/limpeza-ponto/listar-funcionarios-cnpj?cnpjId=' + id);
    }

    excluirPontoPeriodo(cnpjId, funcionarioIds, dataInicial, dataFinal) {
        // Formatar datas para o formato esperado pela API (yyyy-MM-dd)
        const formatarData = (data) => {
            if (!data) return null;
            const dia = String(data.getDate()).padStart(2, '0');
            const mes = String(data.getMonth() + 1).padStart(2, '0');
            const ano = data.getFullYear();
            return `${ano}-${mes}-${dia}`;
        };

        const requisicao = {
            cnpjId: cnpjId,
            funcionarioIds: funcionarioIds,
            dataInicial: formatarData(dataInicial),
            dataFinal: formatarData(dataFinal)
        };
        return http.post('/api/adm/limpeza-ponto/excluir-periodo', requisicao);
    }
}
